import type { AppRouteRecordRaw } from '@/router/types'

export const followRecordRoutes: AppRouteRecordRaw[] = [
  {
    path: 'followRecord',
    name: 'FollowRecord',
    component: () => import('@/views/followRecord/index.vue'),
    meta: { title: '跟进记录', keepAlive: true }
  }
]
